import React, { forwardRef, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Card, Grid } from "@mui/material";
import { Avatar } from "@material-ui/core";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FaFilePdf } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import useDepartmentSelector from "../../../TCPForms/hooks/useDepartmentSelector";
import { urlImg } from "../../components/data";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import ButtonWrapper from "../../components/Button";
import { SummaryCard } from "../../components/StyledComponent";

const OwnerSummary = forwardRef(({ formData, ref }) => {
    const [, applicationFlow] = useDepartmentSelector();
    const { t } = useTranslation()
    const [, setIsPreviewLoading] = useState(false);
    const descriptionOfLand = formData?.descriptionOfLand;
    const properties = descriptionOfLand?.properties
    const owners = formData?.landInfo?.owners;
    const applicant = formData?.applicant
    const documents = formData?.documents
    const bankInfo = formData?.landInfo?.bankdetails
    const authorization = documents?.filter(doc => ["authorization Letter"].includes(doc.documentType))?.[0]?.fileStoreId;
    const filteredDocuments = documents?.filter(doc => !/^(signature|applicantPhoto)\[\d+\]$/.test(doc.documentType));
    const nameOfDepartment = applicationFlow == "DA" ? "DEVELOPMENT AUTHORITY" : "AWAS EVAM VIKAS PARISHAD";

    return (
            <div
                style={{
                    backgroundColor: "#ffffff",
                }}
                ref={ref}
            >
                <div style={{ display: "flex", padding: "5px", background: "rgb(230, 239, 248)" }}>
                    <div style={{ background: "white", borderRadius: "50%" }}>
                        <img width="60" height="30" src={urlImg} alt="Uttar-Pradesh-Logo" />
                    </div>
                    <div style={{ color: "#1f4a7c" }}>
                        <p style={{ marginLeft: "12px", fontSize: "1.25rem", fontWeight: "600", fontFamily: '"Calibri", sans-serif' }}>{nameOfDepartment}</p>
                        <p style={{ marginLeft: "12px", fontFamily: '"Calibri", sans-serif', fontWeight: "500" }}>Government of Uttar Pradesh</p>
                    </div>
                </div>

                <div className="groupContainer" style={{ width: "100%", marginTop: "1rem" }}>

                    <SummaryCard className="formContainer">
                        <div className="formHeaderContainer">
                            <h2 className="formHeading">{t('Basic Information')}</h2>
                        </div>
                        <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                            <div style={{ width: "100%" }}>
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <tbody>
                                        {formData?.ownerOrApplicant && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Are You the Owner or Applicant</b>
                                                </td>
                                                <td>
                                                    {formData?.ownerOrApplicant?.charAt(0).toUpperCase() + formData?.ownerOrApplicant?.slice(1)}
                                                </td>
                                            </tr>
                                        )}
                                        {formData?.approvedLayout && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Is Your Property Part of Approved Layout:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{formData?.approvedLayout?.charAt(0).toUpperCase() + formData?.approvedLayout?.slice(1)}</td>
                                            </tr>
                                        )}
                                        {formData?.morethanOneOwner && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Is More than One Owner:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{formData?.morethanOneOwner?.charAt(0).toUpperCase() + formData?.morethanOneOwner?.slice(1)}</td>
                                            </tr>
                                        )}
                                        {formData?.morethanOneProperty && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Is More than One Property:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{formData?.morethanOneProperty?.charAt(0).toUpperCase() + formData?.morethanOneProperty?.slice(1)}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </SummaryCard>

                    {/* Applicant Information */}
                    {applicant?.name && <SummaryCard className="formContainer">
                        <div className="formHeaderContainer">
                            <h2 className="formHeading">Applicant Information</h2>
                        </div>
                        <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                            <div style={{ width: "100%" }}>
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <tbody>
                                        {applicant?.name && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Name:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{formData.professionalInformation.name}</td>
                                            </tr>
                                        )}
                                        {applicant?.mobileNumber && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Mobile No:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{applicant?.mobileNumber}</td>
                                            </tr>
                                        )}
                                        {applicant?.emailId && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>E-mail Id:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{applicant?.emailId}</td>
                                            </tr>
                                        )}
                                        {applicant?.aadhaarNumber && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Aadhaar No:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{applicant?.aadhaarNumber}</td>
                                            </tr>
                                        )}
                                        {applicant?.address && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Address:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{applicant?.address}</td>
                                            </tr>
                                        )}
                                        {applicant?.address && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Authorization Letter:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>
                                                    <FaFilePdf
                                                        color="#a10505"
                                                        style={{ width: '20px', height: '30px' }}
                                                        onClick={() => getDocumentByFileStoreId(authorization, setIsPreviewLoading)}
                                                    />
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </SummaryCard>}

                    <SummaryCard className="formContainer">
                        {owners?.map((item, index) => (
                            <React.Fragment>
                                <div className="formHeaderContainer">
                                    <h2 className="formHeading">{index > 0 ? 'Addition Owner Information' : 'Owner Information'}</h2>
                                </div>
                                <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                                    <div style={{ width: "100%" }}>
                                        <div>
                                            <div
                                                key={index}
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    flexWrap: "wrap",
                                                    marginTop: "15px",
                                                    marginBottom: "15px",

                                                    paddingBottom: "15px",
                                                }}
                                            >
                                                {/*  */}
                                                <div style={{ flex: "1 1 calc(50% - 10px)", marginRight: "10px" }}>
                                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                                        <tbody>
                                                            {item?.name && (
                                                                <tr>
                                                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                                                        <b>Name :</b>
                                                                    </td>
                                                                    <td style={{ padding: "8px" }}>{item?.name}</td>
                                                                </tr>
                                                            )}
                                                            {item?.fatherOrHusbandName && (
                                                                <tr>
                                                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                                                        <b>Father Name :</b>
                                                                    </td>
                                                                    <td style={{ padding: "8px" }}>{item?.fatherOrHusbandName}</td>
                                                                </tr>
                                                            )}
                                                            {item?.mobileNumber && (
                                                                <tr>
                                                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                                                        <b>Mobile Number :</b>
                                                                    </td>
                                                                    <td style={{ padding: "8px" }}>{item?.mobileNumber}</td>
                                                                </tr>
                                                            )}
                                                            {item?.aadhaarNumber && (
                                                                <tr>
                                                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                                                        <b>Aadhaar Number :</b>
                                                                    </td>
                                                                    <td style={{ padding: "8px" }}>{item?.aadhaarNumber}</td>
                                                                </tr>
                                                            )}
                                                            {formData?.applicationNo && (
                                                                <tr>
                                                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                                                        <b>Application Number :</b>
                                                                    </td>
                                                                    <td style={{ padding: "8px" }}>{formData?.applicationNo}</td>
                                                                </tr>
                                                            )}
                                                            {item?.gender && (
                                                                <tr>
                                                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                                                        <b>Gender :</b>
                                                                    </td>
                                                                    <td style={{ padding: "8px" }}>{item?.gender}</td>
                                                                </tr>
                                                            )}
                                                            {item?.emailId && (
                                                                <tr>
                                                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                                                        <b>E-mail ID :</b>
                                                                    </td>
                                                                    <td style={{ padding: "8px" }}>{item?.emailId}</td>
                                                                </tr>
                                                            )}
                                                            {item?.correspondenceAddress?.state && (
                                                                <tr>
                                                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                                                        <b>State :</b>
                                                                    </td>
                                                                    <td style={{ padding: "8px" }}>{item?.correspondenceAddress?.state}</td>
                                                                </tr>
                                                            )}
                                                            {item?.address && (
                                                                <tr>
                                                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                                                        <b>Address :</b>
                                                                    </td>
                                                                    <td style={{ padding: "8px" }}>{item?.address}</td>
                                                                </tr>
                                                            )}
                                                            {item?.correspondenceAddress?.pinno && (
                                                                <tr>
                                                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                                                        <b>Pin Code :</b>
                                                                    </td>
                                                                    <td style={{ padding: "8px" }}>{item?.correspondenceAddress?.pinno}</td>
                                                                </tr>
                                                            )}
                                                            {item?.correspondenceAddress?.town && (
                                                                <tr>
                                                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                                                        <b>City :</b>
                                                                    </td>
                                                                    <td style={{ padding: "8px" }}>{item?.correspondenceAddress?.town}</td>
                                                                </tr>
                                                            )}
                                                            {item?.statusType && (
                                                                <tr>
                                                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                                                        <b>Applicant Status :</b>
                                                                    </td>
                                                                    <td style={{ padding: "8px" }}>{item?.statusType}</td>
                                                                </tr>
                                                            )}
                                                            {item?.remarks && (
                                                                <tr>
                                                                    <td style={{ textAlign: "left", padding: "8px", width: "50%" }}>
                                                                        <b>Remarks :</b>
                                                                    </td>
                                                                    <td style={{ padding: "8px" }}>{item?.remarks}</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {item?.photo && (
                                                    <div
                                                        style={{
                                                            flex: "1 1 calc(50% - 10px)",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "space-around",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <div className="row" style={{ marginBottom: "10px" }}>
                                                            {item?.photo ? (
                                                                <img
                                                                    style={{ width: "200px", height: "180px", objectFit: "cover" }}
                                                                    src={item?.photo}
                                                                    alt={"image"}
                                                                    className="img-thumbnail"
                                                                />
                                                            ) : (
                                                                <Avatar style={{ width: "200px", height: "80px" }}>{item?.photo}</Avatar>
                                                            )}
                                                        </div>
                                                        <div className="row" style={{ marginBottom: "10px" }}>
                                                            {item?.signature ? (
                                                                <img style={{ width: "200px", height: "80px" }} src={item?.signature} alt={"signature"} className="img-thumbnail" />
                                                            ) : (
                                                                <BorderColorIcon style={{ width: "70px", height: "25px" }}>{item?.signature}</BorderColorIcon>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        ))}

                    </SummaryCard>

                    <SummaryCard className="formContainer">
                        {properties?.map((item, index) => (
                            <React.Fragment defaultExpanded key={index}>
                                <div className="formHeaderContainer">
                                    <h2 className="formHeading">{index > 0 ? 'Additional Registration Information' : 'Registration Information'}</h2>
                                </div>
                                <div className="formInputContainer" style={{ margin: "0px 4px", display: "flex", justifyContent: "center" }}>
                                    <table style={{ width: "100%" }}>
                                        <tbody>
                                            {item.schemeName && (
                                                <tr>
                                                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                        <b>Scheme Type :</b>
                                                    </td>
                                                    <td style={{ width: "50%", padding: "8px" }}>{item.schemeName}</td>
                                                </tr>
                                            )}
                                            {item.appliedLandUse?.name && (
                                                <tr>
                                                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                        <b>Applied Land Use :</b>
                                                    </td>
                                                    <td style={{ width: "50%", padding: "8px" }}>{item.appliedLandUse?.name}</td>
                                                </tr>
                                            )}
                                            {item.khatauniNo && (
                                                <tr>
                                                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                        <b>Khatauni No. :</b>
                                                    </td>
                                                    <td style={{ width: "50%", padding: "8px" }}>{item.khatauniNo}</td>
                                                </tr>
                                            )}
                                            {item.khataNo && (
                                                <tr>
                                                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                        <b>Khata No. :</b>
                                                    </td>
                                                    <td style={{ width: "50%", padding: "8px" }}>{item.khataNo}</td>
                                                </tr>
                                            )}
                                            {item.khasraNo && (
                                                <tr>
                                                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                        <b>Khasra No. :</b>
                                                    </td>
                                                    <td style={{ width: "50%", padding: "8px" }}>{item.khasraNo}</td>
                                                </tr>
                                            )}
                                            {item.plotNo && (
                                                <tr>
                                                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                        <b>Plot No. :</b>
                                                    </td>
                                                    <td style={{ width: "50%", padding: "8px" }}>{item.plotNo}</td>
                                                </tr>
                                            )}
                                            {item.roadWidth && (
                                                <tr>
                                                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                        <b>Road Width :</b>
                                                    </td>
                                                    <td style={{ width: "50%", padding: "8px" }}>{item.roadWidth}</td>
                                                </tr>
                                            )}
                                            {item.plotArea && (
                                                <tr>
                                                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                        <b>Plot Area :</b>
                                                    </td>
                                                    <td style={{ width: "50%", padding: "8px" }}>{item.plotArea}</td>
                                                </tr>
                                            )}
                                            {item.propertyType?.name && (
                                                <tr>
                                                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                        <b>Property Type :</b>
                                                    </td>
                                                    <td style={{ width: "50%", padding: "8px" }}>{item.propertyType?.name}</td>
                                                </tr>
                                            )}
                                            {/* Concatenated Address */}
                                            {(item.propertyAddress?.address || item.city || item.propertyAddress?.pinno) && (
                                                <tr>
                                                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                        <b>Address :</b>
                                                    </td>
                                                    <td style={{ width: "50%", padding: "8px" }}>
                                                        {`${item.propertyAddress?.address || ''}, ${item.city || ''}, ${item.propertyAddress?.pinno || ''}`}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </React.Fragment>
                        ))}
                    </SummaryCard>
                    <SummaryCard className="formContainer">
                        <div className="formHeaderContainer">
                            <h2 className="formHeading">Bank Details</h2>
                        </div>
                        <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                            <div style={{ width: "100%" }}>
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <tbody>
                                        {bankInfo?.accountHolderName && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Account Holder Name:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{bankInfo?.accountHolderName}</td>
                                            </tr>
                                        )}
                                        {bankInfo?.accountNo && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Account No:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{bankInfo?.accountNo}</td>
                                            </tr>
                                        )}
                                        {bankInfo?.bankName && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Bank Name:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{bankInfo?.bankName}</td>
                                            </tr>
                                        )}
                                        {bankInfo?.branchName && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Branch Name:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{bankInfo?.branchName}</td>
                                            </tr>
                                        )}
                                        {bankInfo?.ifscCode && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>IFSC Code:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{bankInfo?.ifscCode}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </SummaryCard>

                    <SummaryCard className="formContainer">
                        <div className="formHeaderContainer">
                            <h2 className="formHeading">Location Information</h2>
                        </div>
                        <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                            <div style={{ width: "100%" }}>
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <tbody>
                                        {descriptionOfLand?.googleMapCoordinates && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Map Cordinates:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>Latitude: {descriptionOfLand?.googleMapCoordinates?.[0]?.latitude}, Longitude: {descriptionOfLand?.googleMapCoordinates?.[0]?.longitude}</td>
                                            </tr>
                                        )}
                                        {descriptionOfLand?.googleMapLocation && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Map Location:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.googleMapLocation}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </SummaryCard>


                    <SummaryCard className="formContainer">
                        <div className="formHeaderContainer">
                            <h2 className="formHeading">Documents Section</h2>{" "}
                        </div>
                        <div className="formInputContainer">
                            <Grid container spacing={2}>
                                {filteredDocuments?.map((document, index) => {
                                    const documentType = document?.documentType?.charAt(0).toUpperCase() + document?.documentType?.slice(1);
                                    return (
                                        <Grid item xs={12} md={6} key={index}> {/* Two items per row on medium screens and above */}
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}><strong>{documentType} </strong>:</Grid> {/* Label part */}
                                                <Grid item xs={6}>
                                                    <FaFilePdf
                                                        color="#a10505"
                                                        style={{ width: '20px', height: '30px' }}
                                                        onClick={() => getDocumentByFileStoreId(document?.fileStoreId, setIsPreviewLoading)}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </div>
                    </SummaryCard>

                    {formData?.checklist?.allotmentDate !== null && <SummaryCard className="formContainer">
                        <div className="formHeaderContainer">
                            <h2 className="formHeading">{t('Checklist Information')}</h2>
                        </div>
                        <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                            <div style={{ width: "100%" }}>
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <tbody>
                                        {formData?.ownerOrApplicant && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Agreement Date:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{formData?.checklist?.agreementDate}</td>
                                            </tr>
                                        )}
                                        {formData?.checklist?.allotmentDate && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Allotment Date:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{formData?.checklist?.allotmentDate}</td>
                                            </tr>
                                        )}
                                        {formData?.checklist?.paymentStatus && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Payment Status:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{formData?.checklist?.paymentStatus}</td>
                                            </tr>
                                        )}
                                        {formData?.checklist?.uptodatePaymentStatus && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Updated Payment Status:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{formData?.checklist?.uptodatePaymentStatus}</td>
                                            </tr>
                                        )}
                                        {formData?.checklist?.isPossesionAreaDiff && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Is Possession Area Different:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{formData?.checklist?.isPossesionAreaDiff}</td>
                                            </tr>
                                        )}
                                        {formData?.checklist?.areaOfExtraLand && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Area Of Extra Land:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{formData?.checklist?.areaOfExtraLand}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </SummaryCard>}
                </div>
            </div>
    );
});
export default OwnerSummary;
